<template>
    <div>
        <b-form-group
        id="input-group-name-accountid"
        label="Descrição"
        label-for="input-name-accountid"
        class="mt-3">
            <b-form-textarea
            id="textarea"
            v-model="internalForm.descricao"
            rows="8"
            ></b-form-textarea>
        </b-form-group>
    </div>
</template>

<script>
import CollapseEditApr from './collapseEditApr'
export default CollapseEditApr
</script>

<style scoped>
.descricao-categoria{
    font-weight: bold;
    font-family: 'Segoe UI';
    font-size: 16px
}
.acesso{
    width: 15%;
}
.col-md-3{
padding-right: 0;
padding-left: 0;
}
.cadastroEdicao{
width: 100%;
}
.container_EditAdd{
width: 100%;
margin-top: 1.5rem;
column-gap: 10px;
}
.nome{
width: 50%;
}
.matricula_cpf{
width: 25%;
}
.email{
width: 49%;
}
.input{
border-radius: 5px;
width: 100%;
}
.title{
font-weight: bold;
font-size: 13px;
color: darkgreen;
}

.margim-top{
margin-top: 1rem;
}

.margim-left{
margin-left: 1rem;
}

.button-cancel,
.button-save{
margin-top: 10;
outline: transparent;
border: transparent;
border-radius: 4px;
text-transform: uppercase;
width: 190px;
height: 40px;
}

.container_cancel_save{
justify-content: center;
width: 100%;
margin-top: 1.5rem;
column-gap: 10px;
}

.button-cancel{
background-color: #b60000;
color: white;
}
.button-save{
background-color: darkgreen;
color: white;

}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/registerApr/components/collapseapr/components/collapseEditApr/collapseEditApr.vue